import { render, staticRenderFns } from "./ExchangeRate.vue?vue&type=template&id=2133b2de&"
import script from "./ExchangeRate.vue?vue&type=script&lang=ts&"
export * from "./ExchangeRate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports